import { FC } from 'react';

import { purpurBreakpointLg, purpurBreakpointMd, purpurBreakpointSm } from '@purpur/library/tokens';

import { ResponsiveImageGroup } from './model';

type Props = {
    images: ResponsiveImageGroup;
    className?: string;
};

export const ResponsiveImage: FC<Props> = ({ images, className }) => {
    const altText = images.altText || images.imageSm.alt || images.imageMd.alt || images.imageLg.alt || '';

    return (
        <picture className={className} data-element="Banner" data-element-name={altText}>
            <source srcSet={images.imageLg.src} media={`(min-width: ${purpurBreakpointLg})`} />
            <source srcSet={images.imageMd.src} media={`(min-width: ${purpurBreakpointMd})`} />
            <source srcSet={images.imageSm.src} media={`(min-width: ${purpurBreakpointSm})`} />
            <img src={images.imageSm.src} alt={altText} role={altText ? 'img' : 'presentation'} />
        </picture>
    );
};
